import { useAlarmWebSocket } from '@/hooks/useAlarmWebSocket';

interface AlarmProviderProps {
  children: React.ReactNode;
}

export function AlarmProvider({ children }: AlarmProviderProps) {
  useAlarmWebSocket();
  return <>{children}</>;
}
